// 康巴圣德（酪蛋白酸钠）下游应用企业分布网络
// 数据来源：企业公开工商/专利/环评/项目备案/年报/行业公开资讯推演，部分字段经联网检索更新（见各公司注释）
// 字段维度：生产动向 production / 专利及发展方向 patent / 产品未来 future / 投资方向 invest / 产品图片 productDesc
// isDownstream:false 表示该公司经公开资料核实与“酪蛋白酸钠下游应用”无直接关联，仅作关联展示、详情页不挂下游标签
// 所有字段固定标准化输出，支持前端 UI 渲染、省份筛选检索。

export const companies = [
  {
    id: 'fujian-bangling',
    name: '福建邦领食品有限公司',
    province: '福建',
    short: '邦领食品',
    category: '植脂末 / 粉末油脂',
    production: `闽粤区域中外合资大型植脂末专业生产企业，厂区面积 1.8 万㎡，拥有 3 条国际先进植脂末生产线，年产能超 5 万吨，可生产含脂率 20%-70% 全系列植脂末。通过 ISO9000、ISO22000、ISO14000 体系认证，2025 年更新生产标准，持续优化茶饮、咖啡专用植脂末生产工艺，量产稳定无停产减产情况。布局海外小包装产品量产，出口西非等海外市场，整体产能利用率长期维持高位。企业以汕头、潮州为核心基地，贴近华南茶饮与咖啡连锁供应链，是区域植脂末稳定的规模化供应商。`,
    patent: `专利布局薄弱，无核心食品配方、乳化工艺发明专利，仅持有少量商标及外观设计。技术以成熟工艺改良为主，无前沿技术研发布局。核心发展方向聚焦性价比商用植脂末规模化生产，深耕咖啡、奶茶、烘焙食品配料赛道，依托闽粤区位优势巩固区域供应链渠道。近年围绕低反式脂肪酸、冷溶速溶等改良方向做小幅配方迭代，但整体研发投入占营收比重较低。`,
    future: `核心主营咖啡植脂末、奶茶植脂末、麦片及烘焙专用植脂末，为酪蛋白酸钠核心下游应用产品。未来持续迭代商用配方，优化零反式脂肪酸产品体系，丰富细分场景专用型号，重点拓展海外大众饮品配料市场，暂无高附加值蛋白基、功能性配料研发布局。企业计划以东南亚、非洲为重点出口市场，提升小包装零售装占比，并探索与连锁茶饮品牌的定制代工合作。`,
    invest: `累计投资超 5000 万元完成厂区及产线建设，现阶段无大额新建、扩产项目。投资重心聚焦生产端品控升级、海外销售渠道铺设，无上游原料布局及深加工产线投资计划，以稳产稳销、巩固现有市场份额为核心策略。近年资本开支以设备自动化、仓储扩容为主，保持轻资产运营。`,
    productDesc: `核心产品为乳白色粉末状商用奶精原料，包含奶茶植脂末、咖啡植脂末、烘焙专用植脂末、海盐奶盖粉等，规格以 25kg 工业袋装、1kg 商用小包装为主，适配茶饮、咖啡、烘焙规模化商用场景。`,
    image: 'assets/company-products/fujian-bangling.png',
  },
  {
    id: 'jiangsu-jiahe',
    name: '苏州佳禾食品工业股份有限公司',
    province: '江苏',
    short: '佳禾食品',
    category: '粉末油脂 / 咖啡 / 植物基',
    production: `国内粉末油脂、植脂末头部企业（A股 605300），2025 年报营收 22.56 亿元，其中咖啡业务 3.61 亿元、同比 +29.59%，植物基 1.30 亿元、同比 +21.55%，粉末油脂 10.58 亿元。2026 年持续产能升级，8000 吨冷热萃取咖啡液产线试产投产，95000 吨 RTD 即饮咖啡产线完成无菌验证；持续迭代低卡、无糖、功能型植脂末产线，淘汰传统高反式配方，生产端聚焦智能化、健康化升级，产能持续稳定释放。公司在苏州、南通等地布局生产基地，是星巴克、瑞幸等头部连锁的核心供应商之一。`,
    patent: `拥有大量粉末油脂、植脂末、植物基食品发明专利，参与起草《植脂末》《粉末油脂》等多项行业国家标准，获国家科学技术进步奖。搭建省级工程技术研究中心、国际联合创新研发平台，冷溶、耐酸、零糖植脂末及发泡粉末油脂已实现量产；技术聚焦健康粉末油脂、植物基替代配料、咖啡全产业链深加工，持续突破低脂、无糖、功能型食品乳化技术，为行业技术标杆企业。截至 2025 年，公司累计专利与软著数量在同业中处于领先梯队。`,
    future: `布局“粉末油脂+咖啡+植物基+创新食品”四大核心赛道，持续产品升级。茶饮端推出牛乳原浆等高端配料，零售端布局有机燕麦奶、Omega-3 功能型植物奶（C 端“非常麦”燕麦奶、“金猫”咖啡）；咖啡端完善全品类深加工产品。未来重点发力高端健康功能性配料，拓展连锁餐饮、新零售、海外市场，持续扩大酪蛋白基高端配料应用场景。公司同步规划即饮咖啡、冻干咖啡等新品类，向消费端品牌化延伸。`,
    invest: `2025 年完成 7.25 亿元定增用于咖啡扩产，2026 年计划投资 10 亿元建设海门超级植物奶智能制造项目。全面推进 0 反式脂肪酸非氢化升级，持续加码咖啡全产业链、植物基新品产能，推进生产数字化转型，布局东南亚海外市场，持续加大研发投入夯实技术壁垒。近年资本开支强度显著高于同业，体现其向咖啡与植物基战略转型的决心。`,
    productDesc: `产品涵盖功能性植脂末、粉末油脂、无菌咖啡液、罐装即饮咖啡、有机植物奶，包含食品级粉末原料、无菌液体饮品、终端罐装成品，适配高端茶饮、精品咖啡、新零售消费场景。`,
    image: 'assets/company-products/jiangsu-jiahe.png',
  },
  {
    id: 'jiangsu-taihe',
    name: '南通泰禾化工股份有限公司',
    province: '江苏',
    short: '泰禾化工',
    category: '农药原药 / 精细化工',
    production: `主营农药原药、功能精细化学品（A股 600526），无食品配料及酪蛋白相关产能、产线布局。2025-02 获环评批复（通数据审批〔2025〕28号）年产 8000 吨苄草丹、5000 吨野麦畏、350 吨电子级羰基硫、3.345 万吨制剂技改项目；2025-09 新建丙类仓库供嘧菌酯项目。推进嘧菌酯扩产、MXDA 中间体扩建、氟唑菌酰胺新建项目，多套中间体产线完成试生产，南通、徐州、江西三大基地稳产增效，生产体系聚焦精细化工植保领域，与食品级酪蛋白应用无关。`,
    patent: `专利集中于绿色农药创制、化工中间体合成、环保化工工艺，拥有 67 项新型杀虫剂核心专利，可自主创制新型农药化合物。深耕植保化工赛道，无食品原料、生物蛋白、食品配料相关技术研发布局。公司与多所高校及科研院所共建联合实验室，在甲氧基丙烯酸酯类杀菌剂、磺酰脲类除草剂方向形成较完整的知识产权护城河。`,
    future: `未来产品管线以新型低毒杀虫剂、杀菌剂、高端农药中间体为主，持续迭代果蔬、水稻专用植保产品，推进新型农药化合物登记落地，拓展全球植保市场，无食品级配料、蛋白基产品研发规划。企业聚焦“创制农药+关键中间体”双轮驱动，强化海外登记与渠道，目标是成为具有全球竞争力的特色农化企业。`,
    invest: `持续加码国内农药产能扩建与工艺升级：2025 年环评技改项目投入约 4720 万元，并投资 1.5 亿美金建设埃及 8 万吨农药及功能化学品海外生产基地，全力布局全球化植保化工产能，不涉及食品原料、生物配料相关投资。资金主要投向高效低毒原药、制剂智能化产线及海外基地，资本开支节奏与农药景气周期高度相关。`,
    productDesc: `主营工业级农药原药、杀菌剂、杀虫剂、精细化工中间体，产品形态为化工粉剂、乳油、工业中间体原料，均为植保化工专用产品，无食品级相关产品。`,
    image: 'assets/company-products/jiangsu-taihe.png',
  },
  {
    id: 'guangdong-maiji',
    name: '佛山麦吉新材料科技有限公司',
    province: '广东',
    short: '麦吉新材',
    category: '水性化学品 / 皮革助剂',
    isDownstream: false,
    production: `专注水性高分子材料、皮革化学品研发生产，2024-07 智慧工厂（约 4500㎡）投产，设计产能 1.5 万吨；2025 年环评公示“年产 3500 吨水性软基涂层复合材料技改项目”。采用精细化、标准化生产模式，主打水性涂层、皮革化工助剂，产能稳定释放，品控及生产合规体系完善，无大规模扩产、减产动作，与食品级酪蛋白应用无关。企业位于佛山三水，依托珠三角家具、制鞋、合成革产业集群，提供水性化替代方案。`,
    patent: `持有国内专利 6 件、商标 8 个，研发聚焦水性化学品、皮革涂饰材料改性工艺，技术以水性环保配方改良、降本增效为主，深耕皮革化工细分赛道，无食品级胶凝助剂、生物基食品配料相关研发布局。公司围绕水性聚氨酯、丙烯酸乳液等方向做应用配方储备，研发规模偏小但定位清晰。`,
    future: `持续迭代水性涂层材料、皮革化工助剂系列产品，重点研发环保型、低气味水性涂饰材料，优化皮革表面处理配方，提升产品稳定性与适用性，深耕皮革、水性材料细分市场，规避食品配料同质化竞争。顺应国家 VOCs 治理与水性化替代趋势，企业有望在合成革、纺织涂层领域扩大份额。`,
    invest: `以研发投入、工艺优化、产品迭代为核心，无大额新建产能规划。重点投入水性材料改性研发实验室升级、精细化生产工艺优化，拓展皮革化工客户渠道，稳步提升高附加值产品产能占比。近年资本开支以技改与环保设施为主，整体保持稳健。`,
    productDesc: `核心产品为水性乳液、水性软基涂层复合材料、皮革涂饰助剂，形态以乳白色水性液体、半透明涂层材料为主，适配皮革制造、水性材料精细化生产场景。`,
    image: 'assets/company-products/guangdong-maiji.png',
  },
  {
    id: 'sichuan-baoshun',
    name: '四川宝顺生物技术有限公司',
    province: '四川',
    short: '宝顺生物',
    category: '功能性蛋白配料 / 培养基原料',
    production: `主营生物食品原料、蛋白深加工，核心产品为胰蛋白胨（胰酪蛋白胨）、食品加工用蛋白肽，是酪蛋白深加工下游应用企业（胰酪蛋白胨源自酪蛋白）。蛋白深加工项目 2025 年环评批复（备案 8000 万），建 2 条线年产 1200 吨食品加工用蛋白肽，2026-06 一阶段竣工调试（年产 720 吨）；中小批量精细化生产，产线运行稳定，无停产、大幅扩产动作。企业位于四川，贴近西南生物医药与食品发酵产业，产品同时供应培养基与功能性食品两条线。`,
    patent: `国家级高新技术企业，自研胰蛋白胨（胰酪蛋白胨）打破国外垄断、降本约 50%，远销 10 余国；拥有多项食品生物配料、蛋白肽制备专利，技术聚焦功能性蛋白配料改性、蛋白胨纯化工艺优化，深耕西南生物食品原料赛道。公司围绕酶解、膜分离、脱盐等核心工序形成自有工艺包，并与地方高校共建蛋白深加工联合实验室。`,
    future: `重点拓展保健品、功能性饮品、休闲食品专用蛋白配料，持续优化蛋白肽、胰蛋白胨配方，开发低负担、健康化功能性配料；拟再投 8000 万元新建 3 条线，5 年产值目标破 1.5 亿元，依托西南产业优势深耕本地市场。企业规划以“蛋白肽+培养基原料”双品类切入大健康与生物制造，提升高附加值产品占比。`,
    invest: `无大额固定资产扩产投资，重心聚焦蛋白肽产线调试、产品配方研发、西南区域渠道拓展；拟再投 8000 万元新建 3 条蛋白肽产线，稳步提升功能性蛋白配料产能与产品品质，走精细化区域深耕路线。资本开支以一期产线达产、二期布局为主，保持稳健现金流。`,
    productDesc: `主营食品级蛋白肽粉、胰蛋白胨（胰酪蛋白胨）、培养基原料，为食品级超细粉末、膏状原料，以工业散装、袋装规格为主，适配保健品、生物发酵、食品配方添加使用。`,
    image: 'assets/company-products/sichuan-baoshun.png',
  },
  {
    id: 'jiangsu-lianfeng',
    name: '常州联丰生物工程有限公司',
    province: '江苏',
    short: '联丰生物',
    category: '食品功能性配料 / 天然添加剂',
    production: `专注生物发酵制品、食品功能性配料、天然食品添加剂生产，核心蛋白基乳化剂、稳定剂产品广泛应用乳蛋白原料。产线标准化程度高，适配乳制品、烘焙、休闲食品中小企业配套需求，常年稳产运行，产能节奏平稳，无重大产能调整。企业位于常州，地处长三角食品配料产业带，为众多区域食品工厂提供稳定供货。`,
    patent: `持有食品生物配料复配、天然添加剂制备实用新型专利，技术以成熟工艺优化、降本增效为主。核心发展方向为通用型食品生物配料规模化、标准化生产，深耕大众基础食品配料赛道，无前沿创新技术布局。公司围绕复配稳定剂、乳化增稠体系积累配方库，研发以应用改良为主。`,
    future: `主打通用型食品稳定剂、乳化剂、增稠剂产品，持续迭代适配乳制品、烘焙食品、休闲零食的基础配料，优化乳蛋白基配料兼容性配方，主打高性价比、高稳定性产品，服务中小食品企业，暂无高端功能性新品布局。企业将顺应清洁标签趋势，逐步降低合成添加剂占比，提升天然来源配料比重。`,
    invest: `投资策略稳健保守，无大额新建、扩产项目，重点投入生产设备维护、工艺标准化升级、品控体系完善，以稳产保供、巩固中小客户市场为核心。资本开支以产线自动化、检测能力为主，保持轻资产、稳现金流的经营风格。`,
    productDesc: `核心产品为通用型食品稳定剂、乳化剂、天然食品增稠剂、生物发酵配料，均为白色食品级粉末原料，广泛适配乳制品、烘焙食品、休闲零食基础生产场景。`,
    image: 'assets/company-products/jiangsu-lianfeng.png',
  },
  {
    id: 'guangdong-yuanjian',
    name: '广东源健食品有限公司',
    province: '广东',
    short: '源健食品',
    category: '食品配料 / 固体饮料',
    production: `华南区域专业食品配料、固体饮料、营养基料生产企业，植脂末、蛋白固体饮料、食品乳化基料等核心产品大量应用酪蛋白酸钠。产线配套齐全，适配新式茶饮、代餐、营养食品量产需求，订单充足，产能稳定释放，持续满产运行。企业位于广东，深度嵌入新式茶饮与代餐供应链，是华南区域重要的标准化配料供应商。`,
    patent: `专利布局较少，仅具备基础生产工艺改良专利，无核心原创配方专利。企业核心发展聚焦华南区域食品配料规模化配套，深耕茶饮、代餐、固体饮料赛道，依托广东食品产业集群优势做标准化配料供应商。研发以配方复制与成本优化为主，技术护城河相对有限。`,
    future: `持续丰富茶饮专用植脂末、代餐蛋白基料、固体饮料配料产品矩阵，迭代适配新式茶饮、轻食代餐的产品配方，扩大酪蛋白基配料应用规模，主打高性价比标准化产品，暂无高端功能性深加工产品规划。企业计划跟随茶饮品牌出海，拓展东南亚代工与出口业务。`,
    invest: `无大规模新建厂区、扩产计划，核心投资用于优化现有产线产能利用率、完善仓储物流配套、小幅升级生产工艺与品控体系，深耕华南本地供应链市场，稳步提升市场占有率。资本开支以仓储扩容与产线提效为主。`,
    productDesc: `主营茶饮专用植脂末、代餐蛋白基料、固体饮料原料、食品乳化基料，为商用标准化白色粉末原料，多为 25kg 工业袋装，适配新式茶饮、代餐、休闲食品规模化量产加工。`,
    image: 'assets/company-products/guangdong-yuanjian.png',
  },
  {
    id: 'hebei-haoshidai',
    name: '好时代胶业迁安有限公司',
    province: '河北',
    short: '好时代胶业',
    category: '乳胶 / 橡胶制品',
    isDownstream: false,
    production: `主营乳胶、橡胶制品，乳胶制品项目分三期建设，一期 6 条气球、手指套生产线，年产气球 7.2 亿个、手指套 18 亿只，2024-07 建成、2025-04 竣工环保验收；三期规划气球产能达 21.6 亿个。产线聚焦乳胶制品标准化量产，适配节日礼品、医疗防护、日用橡胶行业需求，产能利用率平稳，无重大产能增减调整，与食品级酪蛋白应用无关。企业位于河北迁安，依托北方橡胶产业基础，产品以外销与节日礼品渠道为主。`,
    patent: `持有 1 项发明专利（2024 授权）、高新技术企业资质，技术聚焦乳胶制品配方改良、环保工艺优化，定位北方区域乳胶制品专业供应商，无食品胶黏剂、生物基胶黏剂相关研发布局。公司围绕低蛋白过敏乳胶、无粉手套等方向做改良，研发规模偏小。`,
    future: `持续迭代乳胶气球、医用手套、手指套等产品，贴合日用橡胶与医疗防护市场需求，优化乳胶制品稳定性、安全性，拓展节日礼品、医疗防护应用场景，逐步扩大北方乳胶制品市场份额。企业将顺应医用防护常态化与环保趋势，提升无粉、低蛋白产品线比重。`,
    invest: `重点投资乳胶制品产线扩建（三期规划）、环保生产工艺升级、生产合规体系完善，适配北方产业政策要求，小幅优化产线性能，无大额跨界扩产计划，稳步提升乳胶制品市场份额。资本开支以三期建设与环保设施为主。`,
    productDesc: `核心产品为乳胶气球、医用手套、手指套、避孕套等橡胶制品，形态为彩色乳胶气球、乳胶手套等成品，属于日用及医疗橡胶制品，无食品级胶凝剂产品。`,
    image: 'assets/company-products/hebei-haoshidai.png',
  },
  {
    id: 'henan-jinyumi',
    name: '河南金玉米生物科技有限公司',
    province: '河南',
    short: '金玉米生物',
    category: '玉米深加工 / 生物基食品原料',
    production: `依托玉米深加工产业，主营生物基食品原料、淀粉衍生物、乳蛋白改性配料、食品乳化稳定剂。厂区规模化量产，产能体量庞大，生产体系成熟稳定，常年满产运行，是中原区域核心生物食品原料供应商，产品广泛适配乳制品、烘焙、饲料行业。企业位于河南驻马店等粮食主产区，原料成本优势显著，形成“玉米—淀粉—深加工配料”一体化产业链。`,
    patent: `国家级科技型中小企业、省级创新型中小企业，拥有玉米深加工、生物配料改性、食品稳定剂制备多项专利（有效实用新型 3 项、软著 2 项），技术聚焦农产品深加工、生物基食品配料复合改性、低成本乳化稳定技术，依托中原粮食原料优势，深耕农产品生物转化赛道。公司与河南农业大学等院校保持产学研合作，持续积累淀粉糖、变性淀粉方向专利。`,
    future: `持续拓展玉米基、乳基复合食品配料品类，与杭州麦克斯合作开发膳食纤维、高纯度低聚糖、麦芽糊精；优化乳制品、烘焙食品、饲料专用蛋白稳定配料配方，依托成本优势做大基础生物原料产能，小幅布局功能性改性配料。企业规划向高附加值功能性糖、益生元方向延伸，提升产品利润水平。`,
    invest: `聚焦农产品深加工产业链升级，持续投入产线智能化改造、节能工艺升级，优化规模化生产体系，巩固成本优势，无跨界投资，深耕生物原料主业。资本开支以淀粉深加工扩能、节能改造为主，保持重资产稳健运营。`,
    productDesc: `主营玉米深加工生物基原料、食品乳化稳定剂、乳蛋白改性配料、饲料添加剂，形态为白色粉末、颗粒状工业原料，适配乳制品、烘焙食品、饲料规模化生产。`,
    image: 'assets/company-products/henan-jinyumi.png',
  },
  {
    id: 'henan-boxin',
    name: '河南博欣生物科技有限公司',
    province: '河南',
    short: '博欣生物',
    category: '新式茶饮配料 / 植脂末',
    production: `浙江博多集团北方核心生产基地，专业生产新式茶饮配料、植脂末、固体饮料、食品小料，核心产线大量使用酪蛋白酸钠原料。定位华北茶饮供应链配套中心，占地 5 万㎡，年产能超 10 万吨；年产 3 万吨植脂末技改项目（投 3200 万）已投产，智能化改造后产能翻番至 4–6 万吨、年产值 2.5 亿元以上、创汇 800 万美元，承接北方连锁茶饮品牌订单，产能持续释放。企业位于河南，是博多集团辐射北方市场的关键制造枢纽。`,
    patent: `授权专利 27 项，与河南农业大学、山西中医药大学共建研发中心，引才 7 名、科技融资 1000 万元；专利集中于茶饮复配配料、植脂末乳化配方、固体饮料制备工艺，技术聚焦新式茶饮专用配料定制化改良、健康功能型与精准营养型粉末油脂研发。公司围绕“茶饮小料+植脂末”形成配方与工艺双重储备。`,
    future: `持续研发适配北方低温仓储、北方市场口味的植脂末、风味固体饮料、茶饮小料产品，拓展华北连锁茶饮、餐饮渠道，同步跟进集团全球化供应链布局，持续扩大酪蛋白原料采购与应用规模。企业规划丰富爆珠、果酱、椰乳等小料品类，向一站式茶饮配料方案商升级。`,
    invest: `作为集团北方重点布局基地，持续推进产能扩建、产线智能化升级（3 万吨技改已投产），优化华北区域供应链布局、降低物流成本，重点投入新品配方研发，无跨界投资计划，聚焦茶饮配料主业扩产增效。资本开支以新基地、智能产线为主。`,
    productDesc: `核心产品为新式茶饮植脂末、风味固体饮料、奶茶爆珠小料、果浆配料、烘焙原料，涵盖粉末、液体、颗粒多形态，为连锁茶饮一站式专用原料。`,
    image: 'assets/company-products/henan-boxin.png',
  },
  {
    id: 'guangdong-duohe',
    name: '广东多合生物科技有限公司',
    province: '广东',
    short: '多合生物',
    category: '功能性保健食品 / 蛋白配料',
    production: `专注功能性保健食品、蛋白粉、固体饮料研发生产，乳制品、饮品、烘焙专用蛋白基助剂深度应用酪蛋白原料。2024-07 “多合公司年产 2.2 万吨健康食品生产项目”立项，投资 3.10 亿元；采用精细化、定制化生产模式，适配中高端食品企业需求，产线运行稳定，品控体系严苛，产能利用率持续提升。企业位于广东，面向粤港澳大湾区健康食品与保健品市场，提供 OEM/ODM 定制。`,
    patent: `持有多项食品复合稳定剂、蛋白乳化技术发明专利，2024-11 获国产保健食品注册证（多合牌大豆膳食纤维乳清蛋白粉、乳铁蛋白乳清蛋白粉），注册商标 138 个；技术优势聚焦高端食品配料复配、功能性助剂改性、饮品体系稳定技术。公司围绕蛋白粉、功能饮品形成注册证+专利组合，合规壁垒较高。`,
    future: `重点发力高端乳制品、低糖功能性饮品、预制食品赛道，持续迭代酪蛋白基稳定、乳化产品，开发低负担健康功能性配料，拓展头部食品品牌客户，持续提升高附加值产品占比。企业规划以“功能蛋白+保健食品”双主线，切入体重管理、运动营养、银发营养等高增长细分市场。`,
    invest: `核心投资用于 3.10 亿元健康食品生产项目建设、研发实验室升级、精细化产线改造、高端客户渠道拓展，持续加大功能性配料研发投入，聚焦高端细分赛道深耕，不盲目开展规模化扩产。资本开支以新基地与研发为主，强调高附加值产能。`,
    productDesc: `主营高端食品复合稳定剂、蛋白乳化助剂、功能性保健食品（蛋白粉、乳清蛋白粉）、烘焙专用辅料，为高纯度食品级精细粉末、罐装成品，适配高端乳制品、低糖功能性饮品、预制食品精细化生产。`,
    image: 'assets/company-products/guangdong-duohe.png',
  },
  {
    id: 'zhejiang-ganwei',
    name: '浙江敢为实业有限公司',
    province: '浙江',
    short: '敢为实业',
    category: '橡胶 / 塑料 / 玩具 / 医疗器械',
    isDownstream: false,
    production: `位于浙江东阳画水镇，经营范围为橡胶、塑料制品、玩具、第一类医疗器械、日用口罩、母婴用品、化妆品、集成电路芯片设计等，注册资本 1000 万元。以橡胶、塑料制品及玩具制造为主，无食品原料、餐饮供应链配料、固体饮料生产业务，与酪蛋白酸钠下游应用无关。企业以中小制造为主，产品面向日用轻工与母婴、医疗耗材等渠道。`,
    patent: `公开专利、知识产权数量较少，无食品配方、饮品基料相关技术；核心发展聚焦橡胶、塑料制品及玩具制造，深耕区域轻工制造市场，无食品配料研发布局。公司研发以模具与工艺改良为主，技术含量相对有限。`,
    future: `以橡胶、塑料制品、玩具及医疗器械为主营，小幅迭代产品工艺，适配日用品、母婴、医疗器械市场需求，持续巩固轻工制造市场份额，无高端功能性、食品配料新品研发布局。企业将顺应母婴与医疗耗材稳健需求，维持现有产品矩阵。`,
    invest: `无大额新建扩产项目，投资重心聚焦产线精细化优化、仓储物流配套升级、区域渠道拓展，小幅投入工艺改良，稳健深耕区域轻工制造赛道。资本开支以设备更新为主，保持轻资产。`,
    productDesc: `核心产品为橡胶、塑料制品、玩具、第一类医疗器械、日用口罩、母婴用品等，为日用轻工制成品，无食品配料、植脂末、固体饮料等酪蛋白相关产品。`,
    image: 'assets/company-products/zhejiang-ganwei.png',
  },
  {
    id: 'jiangxi-hengding',
    name: '江西恒顶食品有限公司',
    province: '江西',
    short: '恒顶食品',
    category: '食品配料 / 植脂末头部',
    production: `全国大型食品配料、植脂末、固体饮料头部生产企业，总投资 23.5 亿元建设“恒顶生物食品健康产业园”（占地 402 亩），一期 6 万吨植脂末 2021 年投产；现年产大米糖浆 20 万吨、植脂末/酶解谷物粉 16 万吨、大米蛋白等 2 万余吨。2026-06 大米蛋白粉俏销海外，1–4 月宜春海关监管出口 1306 吨、货值 2892 万元，长期满产运行，供货全国头部品牌。企业位于江西宜春，形成“稻谷副产物—植脂末/大米蛋白”循环产业链。`,
    patent: `累计 54 项专利，建有“江西省稻谷附产品高值化利用工程研究中心”、院士工作站，获 2023/2024 省科技进步奖一等奖、2025 高企证书；2025 年省新产品“大米发泡粉”上市，技术聚焦规模化商用食品配料优化、大米蛋白肽高值化、风味改良、稳定体系升级。公司围绕稻米深加工形成从专利到新产品的完整转化链条。`,
    future: `持续丰富全系列商用植脂末、风味固体饮料、烘焙配料产品矩阵，迭代健康化、低负担产品配方，主推大米蛋白粉/肽、植物基产品，适配新式茶饮、健康冲调食品发展趋势，稳定酪蛋白原料采购需求，持续扩大中高端市场份额。企业规划放大稻米蛋白出口与植物基配料，提升产业链附加值。`,
    invest: `持续推进 23.5 亿元健康产业园建设，投入智能化产线升级、产能优化、新品研发，完善全国仓储配送体系，依托规模优势降本增效，巩固行业头部地位，聚焦食品配料主业深耕。资本开支强度大，重资产扩张特征明显。`,
    productDesc: `主营全系列商用植脂末、咖啡配料、奶茶原料、烘焙基料、风味固体饮料、大米蛋白粉/肽，为多规格工业袋装白色粉末原料，覆盖高中低端茶饮、烘焙、冲调食品全应用场景。`,
    image: 'assets/company-products/jiangxi-hengding.png',
  },
  {
    id: 'jiangxi-changhui',
    name: '江西长汇食品有限公司',
    province: '江西',
    short: '长汇食品',
    category: '中端植脂末 / 固体配料',
    production: `中部区域专业植脂末、固体食品配料生产企业，4 条植脂末生产线、年产能 7 万吨（原 5 万吨），占地 40 亩、员工 146 人，高新技术、专精特新、科技型中小企业。奶茶、咖啡、烘焙专用植脂末核心原料包含酪蛋白酸钠，产线标准化量产，适配中小茶饮、烘焙品牌客户，产能稳定，生产节奏平稳。企业位于江西，是中部下沉市场重要的中端植脂末供应商。`,
    patent: `授权专利 55 项、商标 4 个，2025 税务 A 级、具独立进出口资质；官网植脂末说明明确“以植物油、麦芽糖浆、酪蛋白为主要原料”，技术聚焦中端商用植脂末规模化生产、风味稳定性配方优化，深耕中部下沉市场。公司围绕风味稳定与成本控制形成配方储备，专利以实用新型为主。`,
    future: `以通用型商用植脂末为核心产品，小幅迭代产品风味、稳定性配方，适配下沉市场茶饮、休闲食品需求；对外投资江西米元素原料科技延伸产业链，持续巩固中端市场份额。企业规划以“植脂末+谷物基配料”拓宽品类，强化中部渠道渗透。`,
    invest: `投资策略稳健，无大额扩产、研发投资，核心投入现有产线维护、工艺优化、区域渠道下沉，聚焦稳产稳销，深耕中部中端食品配料市场。资本开支以设备维护与小幅技改为主。`,
    productDesc: `核心产品为中端奶茶、咖啡专用植脂末、烘焙固体配料、食品乳化原料，标准化白色粉末商用配料，主打高性价比，适配中小茶饮、烘焙企业生产使用。`,
    image: 'assets/company-products/jiangxi-changhui.png',
  },
  {
    id: 'shandong-chunhua',
    name: '潍坊春华化工有限公司',
    province: '山东',
    short: '春华化工',
    category: '化工贸易',
    isDownstream: false,
    production: `微型化工贸易企业（注册资本 50 万元），经营范围为销售化工原料、印染助剂及化学试剂（不含危化品）、化学仪器，国标行业为“其他化工产品批发”，无自有生产产线、无食品级资质信息，与食品级精细助剂、酪蛋白改性生产技术无关。企业以渠道贸易为主，不从事制造，规模较小。`,
    patent: `公开知识产权极少，无食品级精细助剂、生物基稳定剂相关专利与研发布局；核心业务聚焦化工原料贸易，无食品工业配套助剂生产能力。公司无自主研发体系，仅为流通环节服务商。`,
    future: `核心业务为化工原料、印染助剂批发贸易，无食品配料、生物新材料产品生产规划，与酪蛋白应用市场无交集。企业将维持现有贸易品类与渠道，无重大转型计划。`,
    invest: `投资聚焦化工贸易渠道与客户维护，无食品生物、精细配料、新材料领域生产投资，不涉及酪蛋白上下游产业。资本开支极低，以流动资金与渠道维护为主。`,
    productDesc: `主营化工原料、印染助剂、化学试剂（非危化品）及化学仪器批发，为工业品贸易品类，无食品级精细助剂、生物基稳定剂等酪蛋白相关产品。`,
    image: 'assets/company-products/shandong-chunhua.png',
  },
  {
    id: 'zhejiang-boduo',
    name: '浙江博多食品科技有限责任公司',
    province: '浙江',
    short: '博多食品',
    category: '新式茶饮一站式供应链',
    production: `博多集团总部运营主体，主营品牌运营、研发、渠道管理，生产制造由集团七大生产基地承接。德清九润基地投资 5.005 亿元，拥有 21 条生产线，年产能 12 万吨；奇异鸟基地年产 6 万吨茶饮配料，河南基地规划 10 万吨级产能，全系植脂末、茶饮配料核心配方均使用酪蛋白酸钠，整体产能持续扩张、满产运行。企业以杭州为总部，构建覆盖全国的茶饮供应链网络。`,
    patent: `母公司以外观专利为主，核心植脂末乳化、茶饮配料制备工艺专利集中在生产子公司。集团技术与发展方向聚焦新式茶饮全品类配料研发、口感体系优化、供应链整合，定位全球新式茶饮一站式供应链服务商，不布局蛋白深加工赛道。公司围绕“配方+供应链”形成轻资产运营核心能力。`,
    future: `持续丰富茶饮植脂末、果酱、爆爆珠、固体饮料、烘焙配料全品类产品，迭代适配新式茶饮、海外市场的定制化配料，拓展东南亚、欧美海外供应链市场，持续稳定采购酪蛋白酸钠，暂无 CPP、酪蛋白肽等高附加值深加工产品布局。企业规划加速海外基地与渠道，成为全球茶饮配料重要供应商。`,
    invest: `重点投资全国多点生产基地建设、博多森谷总部产业园、海外子公司及全球化供应链体系，加码产能扩张与海外渠道布局，投资 20 余家产业链企业完善茶饮供应链生态，无上游原料自建布局。资本开支以基地建设与股权并购为主，扩张激进。`,
    productDesc: `产品矩阵包含茶饮植脂末、风味果酱、爆爆珠小料、固体饮料、烘焙配料、连锁茶饮定制原料，涵盖粉末、液体、颗粒、凝胶多形态，是新式茶饮一站式全品类配套原料。`,
    image: 'assets/company-products/zhejiang-boduo.png',
  },
  {
    id: 'sichuan-jiahe-group',
    name: '成都嘉禾实业集团有限公司',
    province: '四川',
    short: '嘉禾实业',
    category: '农业产业化 / 综合实业',
    production: `综合性实业集团，主营农副产品加工、种业种植、交通工程、地产配套、酒类产业，无食品配料、植脂末、生物乳化助剂等酪蛋白相关产能与产线。各主业板块生产运营稳定，无扩产、技改、停产动作，完全不涉及酪蛋白原料采购、加工、应用业务。集团以四川为根基，业务横跨农业、基建、酒业与服务业。`,
    patent: `公开知识产权极少，仅持有少量农业种植、种业相关技术，无食品配方、生物改性、食品乳化相关专利与研发布局。核心发展方向聚焦农业产业化、基建工程、地产商贸服务，完全不涉足食品生物配料、蛋白深加工赛道。`,
    future: `核心业务为农作物种子、农副产品初加工、工程配套、酒类产品、商业物业服务，无任何酪蛋白下游相关产品。未来持续深耕原有多元主业，无切入食品配料、生物新材料赛道的公开规划，与酪蛋白应用市场无交集。`,
    invest: `投资聚焦本地农业、基建、地产、商贸领域，2025 年新增布局餐饮娱乐、检测技术相关企业，围绕原有主业补链扩链，无食品生物、精细配料、新材料领域投资，不涉及酪蛋白上下游产业。资本开支以多元化实业投资为主。`,
    productDesc: `主营农副产品、农作物种子、酒类产品、工程配套设施、商业物业服务相关产品及服务，无食品配料、生物助剂、植脂末等酪蛋白相关产品。`,
    image: 'assets/company-products/sichuan-jiahe-group.png',
  },

  // ===== 以下为联网检索补充的「酪蛋白 / 酪蛋白酸钠」相关下游及行业企业（excludeFromMap：仅进入下游客户热力图，不污染经营数据页地图） =====
  // 数据来源：企业公开年报 / 招股书 / 官网 / 行业公开报道与行情资讯（2025-2026），仅供市场调研与数字看板展示
  {
    id: 'milkground',
    name: '上海妙可蓝多食品科技股份有限公司',
    province: '上海',
    short: '妙可蓝多',
    category: '再制奶酪 / 原制奶酪',
    excludeFromMap: true,
    production: `国内奶酪行业龙头（A股 600882），2025 年营收 56.32 亿元、同比 +16.29%，2026 一季度营收 16.26 亿元、同比 +31.81%，部分定制化产品阶段性供不应求。依托控股股东内蒙蒙牛体系协同，推进奶酪加工与乳清处理关键技术，落地 MCC 酪蛋白胶束等高附加值产品；依托长春工厂（年产 3 万吨级原制奶酪）稳定供应体系内需求。公司近年来加快常温奶酪、家庭烘焙奶酪等新品铺货，并拓展餐饮与电商渠道，是儿童奶酪棒品类的开创者与领导者。`,
    patent: `与吉林大学联合开发奶酪加工与乳清处理关键技术，优化乳清蛋白粉制备工艺、提升蛋白含量与功能性指标；专利集中于再制奶酪乳化、原制奶酪量产、乳清深加工等方向，持续强化乳蛋白高值化利用技术壁垒。公司围绕奶酪质构、风味与乳清资源化形成专利组合，并参与多项行业标准的制定。`,
    future: `覆盖全年龄段奶酪产品矩阵（成长酪乳、奶酪小金袋、奶酪小三角等），以高钙、高蛋白、低卡轻负担贴合健康趋势；稳定乳清资源高附加值开发，重点布局功能营养、运动营养等高增长品类，持续扩大乳蛋白应用规模。公司规划以“奶酪+乳蛋白”双引擎，向成人营养与餐饮工业奶酪延伸，巩固品类心智。`,
    invest: `依托蒙牛上游原料协同（D90 脱盐乳清粉、乳铁蛋白、MCC 酪蛋白胶束），深化产业链上游供应与技术产业化合作；贸易业务（黄油、奶粉、乳清粉、车达等）2025 年营收 6.23 亿元、同比 +17.44%，强化供应链稳定性。公司持续投入产能扩建与渠道下沉，并与蒙牛体系内共享奶源与研发资源。`,
    productDesc: `主营再制奶酪、原制马苏里拉 / 马斯卡彭、奶酪棒 / 奶酪零食、乳清蛋白粉等，为块状、条状、杯装及粉末多形态乳制品，是国内奶酪消费渗透核心推动者。`,
    image: '',
  },
  {
    id: 'yili',
    name: '内蒙古伊利实业集团股份有限公司',
    province: '内蒙古',
    short: '伊利股份',
    category: '乳制品全产业链 / 奶酪 / 乳清深加工',
    excludeFromMap: true,
    production: `中国最大乳制品企业，全球建成 77 个生产基地、15 个创新中心。2025 年建成国内首条商业化脱盐乳清粉生产线（年处理 4 万吨甜乳清液），2026-03 奶酪三期 1 万吨原制马苏里拉产线投产；呼和浩特智慧健康谷奶粉三期、奶酪三期等重大项目落地，乳业工业产值向 600 亿元迈进。公司液态奶、奶粉、酸奶、冰淇淋、奶酪全品类布局，并加速乳清与酪蛋白国产化替代。`,
    patent: `国家级乳业技术创新中心集聚 10 余位院士、超 5000 人全产业链创新队伍，累计国内外发明专利授权 1049 件（居中国乳企第一）；在高效分离制备乳铁蛋白、β-酪蛋白等技术取得标志性创新，掌握“活性智护杀菌”“晶态定向调控”等全球领先技术。公司构建了从原料到终端的全链路知识产权体系。`,
    future: `依托全产业链布局持续发力乳清国产化与奶酪精深加工，强化原制奶酪、脱盐乳清粉、乳铁蛋白等高附加值产品自给；顺应清洁标签与高蛋白趋势，扩大功能营养、临床营养品类，巩固国内乳业龙头地位。公司规划以“全球乳业前五”为目标，提升高附加值乳蛋白与营养品占比。`,
    invest: `持续投入乳品精深加工产能（脱盐乳清粉、奶酪三期、乳蛋白深加工项目），在乳清 / 酪蛋白国产替代领域重点布局；2025 年呼和浩特推动伊利智慧健康谷等重大项目建设，夯实产业底座。资本开支强度居行业前列，聚焦深加工与研发基础设施。`,
    productDesc: `产品涵盖液态奶、奶粉、酸奶、冰淇淋、原制 / 再制奶酪、脱盐乳清粉、乳铁蛋白等高附加值乳蛋白配料，为液态、固态、粉末多形态，覆盖全龄段营养需求。`,
    image: '',
  },
  {
    id: 'mengniu',
    name: '中国蒙牛乳业有限公司',
    province: '内蒙古',
    short: '蒙牛',
    category: '乳制品 / 奶酪 / 乳清蛋白',
    excludeFromMap: true,
    production: `国内头部乳制品企业（HK2319），旗下妙可蓝多已实现原制奶酪规模化生产；2026-01“奶立方”项目投产，聚焦 D90 脱盐乳清粉自主研发，已实现 D90 脱盐乳清粉、乳铁蛋白等产品下线，填补国内高端乳清原料产业化空白；冰淇淋品牌艾雪在印尼年营收突破 20 亿元。公司液态奶、酸奶、奶酪、冰淇淋、奶粉全品类布局，并加速东南亚等海外市场拓展。`,
    patent: `依托“农业农村部乳品精深加工重点实验室”（国内乳业唯一获批企业重点实验室），自主研发母乳低聚糖（HHS）通过国家审批；在乳清蛋白、乳铁蛋白、酪蛋白胶束等核心配料取得一批工艺突破，牵头中国百万奶牛基因改良计划。公司围绕核心乳蛋白配料形成工艺与专利双重储备。`,
    future: `围绕奶酪、乳脂、乳清等深加工推进国产替代，借助蒙牛体系内协同提升乳蛋白综合利用率；持续布局功能营养、运动营养高增长品类，强化蛋白原料自给与高附加值转化。公司规划以“乳清国产化+奶酪深加工”为战略支点，提升产业链自主可控水平。`,
    invest: `重点投资 D90 脱盐乳清粉、乳铁蛋白、原制奶酪等精深加工产能，依托内蒙古奶业集群与政策补贴（精深加工设备投资 10% 最高 5000 万元）加速产能落地。资本开支聚焦高附加值深加工与海外基地，重研发、重产业链。`,
    productDesc: `主营液态奶、酸奶、冰淇淋、奶酪、D90 脱盐乳清粉、乳铁蛋白、酪蛋白胶束等乳蛋白配料，为液态、固态及粉末多形态，服务饮料、烘焙、营养多场景。`,
    image: '',
  },
  {
    id: 'feihe',
    name: '中国飞鹤有限公司',
    province: '黑龙江',
    short: '飞鹤',
    category: '婴幼儿配方奶粉 / 乳蛋白',
    excludeFromMap: true,
    production: `国内婴幼儿配方奶粉龙头（HK6186），2024 年实现脱盐乳清、乳铁蛋白等多种重要原料工业化生产；2025 年于内蒙古赤峰市投建二期乳品深加工项目，继续布局脱盐乳清和酪蛋白生产；拥有 16 种关键核心原料自研自产能力，乳铁蛋白纯度稳定 95% 以上。公司依托黑龙江自有奶源与“2 小时生态圈”，实现从鲜奶到成品的全程可控。`,
    patent: `2012 年建成脱盐乳清液生产线率先打破国外垄断，2022 年建成国内首条乳铁蛋白自动化生产线；2025 年发布“乳蛋白鲜萃活性工艺”，直接从鲜奶萃取乳清蛋白、绕开传统“先做奶酪再提乳清”路线，最大程度保留天然活性成分。公司围绕活性乳蛋白形成领先工艺与专利壁垒。`,
    future: `以鲜奶直萃活性乳蛋白工艺为核心，持续扩大脱盐乳清、酪蛋白、乳铁蛋白等核心原料自主化；顺应婴配粉核心原料国产化趋势，降低对进口乳清蛋白的依赖。公司规划以“鲜萃活性技术”向全龄营养与功能蛋白延伸，提升产业链话语权。`,
    invest: `持续投入乳品深加工与核心原料自研产线（赤峰二期、乳铁蛋白、脱盐乳清、酪蛋白），强化上游原料自主可控，提升产业链综合盈利水平。资本开支以核心原料产线与奶源基地为主，强调垂直一体化。`,
    productDesc: `主营婴幼儿配方奶粉、乳铁蛋白、脱盐乳清粉、酪蛋白等乳蛋白原料及终端奶粉产品，为粉末、罐装多形态，聚焦婴配与功能营养。`,
    image: '',
  },
  {
    id: 'bright-dairy',
    name: '光明乳业股份有限公司',
    province: '上海',
    short: '光明乳业',
    category: '液态奶 / 酸奶 / 奶酪',
    excludeFromMap: true,
    production: `华东区域老牌乳制品龙头（A股 600597），以低温鲜奶、酸奶、奶酪为核心品类，依托“优倍”“莫斯利安”等品牌稳定供应；低温酸奶与鲜奶渠道优势明显，持续迭代高蛋白、功能性乳品。公司拥有华东密集的冷链与短保鲜奶网络，并布局奶酪与奶粉业务，是区域乳企标杆。`,
    patent: `技术聚焦低温乳品发酵、乳蛋白稳态化、奶酪工艺改良，建有乳品研发中心与菌种资源体系；在巴氏鲜奶活性保留、酸奶质构稳定等方向拥有成熟工艺积累。公司围绕自有菌种与冷链保鲜形成技术特色，并参与多项乳品标准制定。`,
    future: `深耕低温乳品与奶酪品类，顺应高蛋白、清洁标签趋势扩大乳蛋白应用；强化华东冷链渠道与新鲜短保产品矩阵，稳固区域乳业领先地位。公司规划以“新鲜战略”为核心，向高附加值鲜奶、奶酪与功能乳品升级。`,
    invest: `稳健投入低温产线升级、冷链物流与产品研发，聚焦华东本地供应链深耕，无大规模跨界扩产。资本开支以冷链、低温产线与研发为主，强调区域深耕与效率。`,
    productDesc: `主营鲜奶、酸奶、奶粉、奶酪、乳蛋白配料等，为液态、固态多形态乳制品，覆盖日常营养与功能乳品场景。`,
    image: '',
  },
  {
    id: 'newhope-dairy',
    name: '新希望乳业股份有限公司',
    province: '四川',
    short: '新希望乳业',
    category: '低温鲜奶 / 酸奶',
    excludeFromMap: true,
    production: `西南区域乳制品头部企业（A股 002946），以“鲜战略”聚焦低温鲜奶与特色酸奶，旗下华西、雪兰等区域品牌覆盖川渝及全国；低温产能与冷链网络持续扩张，鲜奶、酸奶产量稳步提升。公司通过并购整合区域乳企，形成“全国布局+区域强势”的鲜奶联盟。`,
    patent: `技术聚焦低温乳品活性保留、发酵菌种选育与乳蛋白稳态化，区域研发中心支撑多品牌产品迭代；在巴氏鲜奶、功能性酸奶方向具备成熟工艺。公司围绕活性菌与鲜奶保鲜构建差异化能力，并持续投入菌种资源库建设。`,
    future: `持续强化“鲜战略”与低温乳品高端化，扩大高蛋白、功能型乳品占比；借西南区位优势深耕本地市场并稳步全国化拓展。公司规划以“24 小时鲜奶”等短保爆品为牵引，提升低温鲜奶渗透率与品牌溢价。`,
    invest: `稳健投入低温产线智能化升级、冷链物流与区域并购整合，巩固西南低温乳业龙头地位。资本开支以冷链、低温产能与并购为主，强调鲜奶供应链壁垒。`,
    productDesc: `主营鲜奶、酸奶、乳蛋白饮品等低温乳制品，为液态、杯装多形态，覆盖日常营养与功能乳品场景。`,
    image: '',
  },
  {
    id: 'hiroad',
    name: '上海海融食品科技股份有限公司',
    province: '上海',
    short: '海融科技',
    category: '植脂奶油 / 含乳脂奶油 / 烘焙原料',
    excludeFromMap: true,
    production: `烘焙茶饮行业专业原料供应商（A股 300915），主营含乳脂植脂奶油、UHT 淡奶油、稀奶油、植脂奶油、蛋白饮料、果酱、巧克力、冰淇淋等；年报明确主要原材料包含**酪蛋白酸钠**（与油脂、稀奶油、淀粉糖等并列），受大宗原料价格波动影响显著。公司在上海、广东等地设生产基地，服务烘焙连锁、茶饮与餐饮客户。`,
    patent: `2024 年获发明专利“一种植物基酪蛋白酸钠替代物的制备及应用”（CN202310509541.6），以植物蛋白分级浸提、适度改性、交联实现乳液体系对酪蛋白酸钠的替代；在奶油乳化、搅打充气稳定性方向持续研发。公司围绕奶油体系与植物基替代形成专利布局，并积极布局海外产能。`,
    future: `深耕烘焙与茶饮大客户定制，拓展餐饮赛道；植物基产品家族（植物基坚果奶油、巴旦木奶等）持续迭代，探索酪蛋白酸钠替代与功能化升级，加速泰国、印度等海外工厂产能释放。公司规划以“奶油+植物基”双轮驱动，切入全球烘焙茶饮供应链。`,
    invest: `推进未来食品产业园建设，印度工厂第二条产线投产（总产能升至 3.5 万吨/年）；已在泰国、印尼、越南等设经销网络，菲律宾、土耳其、马来西亚设销售子公司，加快全球化布局。资本开支以海外产能与产业园为主，扩张积极。`,
    productDesc: `主营奶油、植物基奶油、蛋白饮料、果酱、巧克力、冷冻烘焙等烘焙茶饮原料，为液态、膏状、粉末多形态，是酪蛋白酸钠的直接工业采购方。`,
    image: '',
  },
  {
    id: 'panda-dairy',
    name: '熊猫乳品集团股份有限公司',
    province: '浙江',
    short: '熊猫乳品',
    category: '炼乳 / 奶油 / 奶酪',
    excludeFromMap: true,
    production: `专业乳制品企业（A股 300898），创建于 1996 年，总部浙江温州，在浙江、山东、海南建生产基地，上海设销售与应用技术服务中心。主营熊猫牌炼乳、奶酪、奶油、奶酱及椰达牌椰浆椰乳，产品多次获行业荣誉。公司炼乳产销量长期居国内前列，同时向奶油、奶酪品类延伸。`,
    patent: `技术聚焦炼乳浓缩、奶酪与奶油工艺改良、乳蛋白稳态化；建有现代管理信息化系统与多项质量认证，持续推动炼乳、奶酪品类升级与品牌国际化。公司围绕炼乳浓缩与乳蛋白稳定形成工艺储备，并推进自动化与绿色生产。`,
    future: `实施品牌提升与国际化战略，扩大炼乳、奶酪、奶油高附加值品类；依托多基地产能拓展餐饮茶饮与零售渠道，提升乳蛋白产品占比。公司规划以“炼乳龙头+奶酪/奶油延伸”提升综合竞争力，并加快出海布局。`,
    invest: `稳健投入炼乳、奶酪、奶油产线升级与区域渠道拓展，在浙、鲁、琼多基地布局保障供应，推进国际化销售网络。资本开支以产线升级与渠道为主，保持稳健扩张。`,
    productDesc: `主营炼乳、奶酪、奶油、奶酱、椰乳等乳制品，为罐装、块状、液态多形态，是乳蛋白与奶油类下游应用企业。`,
    image: '',
    },
  {
    id: 'xiangpiao',
    name: '香飘飘食品股份有限公司',
    province: '浙江',
    short: '香飘飘',
    category: '杯装奶茶 / 即饮 / 植脂末饮品',
    excludeFromMap: true,
    production: `杯装奶茶与即饮饮品头部企业（A股 603711），总部浙江湖州，2024 年营收约 10.87 亿元，拥有 3 项发明、15 项实用新型、103 项外观专利。主营即饮类产品、奶茶固体饮料，是植脂末 / 含乳饮料大规模下游用户，配套包装杯、盒、箱供应链。公司杯装奶茶连续多年市占领先，并加速即饮乳茶与功能饮品布局。`,
    patent: `参与国家标准与团体标准制定，拥有“即饮类产品”“乳制品生产”等资质，农业产业化龙头企业；在杯装奶茶、即饮乳茶配方与包装自动化方向有成熟专利积累。公司围绕冲泡与即饮双形态形成配方、工艺与包装专利组合。`,
    future: `持续迭代杯装奶茶与即饮乳茶产品矩阵，顺应健康化趋势优化配方；依托品牌与渠道优势扩大含乳饮料、固体冲调品类市场份额。公司规划以“冲泡+即饮”双轮驱动，向功能化、低糖化与年轻化产品升级。`,
    invest: `聚焦主业产线自动化与渠道深耕，稳健投入即饮新品研发与品牌传播，无大规模跨界扩产。资本开支以即饮产线与品牌为主，强调稳健经营。`,
    productDesc: `主营杯装奶茶、即饮乳茶、奶茶固体饮料、含乳饮料等，为杯装、瓶装、袋装多形态，是植脂末与含乳蛋白饮品大规模下游。`,
    image: '',
  },
  {
    id: 'ligao',
    name: '立高食品股份有限公司',
    province: '广东',
    short: '立高食品',
    category: '烘焙原料 / 奶油 / 冷冻烘焙',
    excludeFromMap: true,
    production: `烘焙与冷冻烘焙原料头部企业（A股 300973），总部广东，主营奶油、水果制品、酱料、冷冻烘焙半成品等，为烘焙连锁与餐饮客户提供一站式原料；持续扩大奶油与冷冻烘焙产能。公司在华南、华东布局生产基地，服务山姆、盒马、连锁烘焙等渠道。`,
    patent: `技术聚焦奶油乳化、搅打充气稳定性、冷冻烘焙工艺改良，拥有成熟烘焙原料复配与冷链适配工艺；在含乳脂奶油、冷冻烘焙半成品方向积累丰富专利。公司围绕“奶油+冷冻烘焙”形成配方、工艺与冷链三重储备。`,
    future: `深耕“大烘焙”渠道并拓展餐饮茶饮大客户，提供个性化定制原料；持续迭代奶油、冷冻烘焙与酱料产品，扩大乳脂与蛋白基配料应用。公司规划以冷冻烘焙半成品为增长极，提升餐饮与零售渠道渗透率。`,
    invest: `稳健投入冷冻烘焙产能与华南生产基地布局，强化烘焙茶饮客户定制与渠道下沉，提升高附加值产品占比。资本开支以冷冻烘焙产线与供应链为主，聚焦主业扩张。`,
    productDesc: `主营奶油、含乳脂奶油、冷冻烘焙半成品、果酱、酱料等烘焙原料，为膏状、冷冻、袋装多形态，是奶油与乳蛋白类下游应用企业。`,
    image: '',
  },
  {
    id: 'byhealth',
    name: '汤臣倍健股份有限公司',
    province: '广东',
    short: '汤臣倍健',
    category: '膳食营养补充剂 / 蛋白粉',
    excludeFromMap: true,
    production: `膳食营养补充剂龙头（A股 300146），总部广东珠海，主营蛋白粉、乳清蛋白粉、大豆膳食纤维乳清蛋白粉等营养品；蛋白类产品是酪蛋白 / 乳清蛋白等乳基蛋白的重要下游应用，依托全球原料采购体系稳定供应。公司拥有透明工厂与多品牌矩阵（汤臣倍健、健力多、Life-Space 等），渠道覆盖药店、电商与商超。`,
    patent: `持有多项营养配方、蛋白复配与功能因子专利，建有自有研发体系与透明工厂；在乳清蛋白、胶原蛋白、功能性蛋白粉方向持续迭代。公司围绕蛋白粉与功能营养形成配方、工艺与标准三重壁垒，并建有营养与健康研究院。`,
    future: `顺应健身与老龄化带来的高蛋白需求，扩大乳清 / 酪蛋白类营养品占比；强化全球原料直采与科学营养品牌战略，提升功能营养品类。公司规划以“科学营养”为核心，向精准营养与个性化补充升级，提升高毛利产品占比。`,
    invest: `稳健投入营养品研发与全球原料供应链，强化珠海总部与生产基地建设，聚焦科学营养赛道深耕。资本开支以研发、产能与渠道为主，强调品牌与研发壁垒。`,
    productDesc: `主营蛋白粉、乳清蛋白粉、益生菌、维生素矿物质等膳食营养补充剂，为罐装、袋装粉末多形态，是乳基蛋白规模化下游用户。`,
    image: '',
  },
  {
    id: 'liziyuan',
    name: '浙江李子园食品股份有限公司',
    province: '浙江',
    short: '李子园',
    category: '含乳饮料',
    excludeFromMap: true,
    production: `含乳饮料区域龙头（A股 605337），总部浙江金华，1994 年成立，集含乳饮料及其他饮料研发、生产、销售于一体；核心“甜牛奶”含乳饮料全国化布局，产线规模化、渠道下沉深入。公司在浙江、江西、河南、云南等多地布局生产基地，形成“总部+多点”供应网络。`,
    patent: `在含乳饮料配方稳定性、杀菌与包装自动化方向有成熟工艺积累，拥有多项饮料生产相关设备与配方专利，农业产业化布局稳定。公司围绕甜牛奶风味稳定与长效保鲜形成工艺特色，并推进产线自动化改造。`,
    future: `持续扩大含乳饮料核心单品全国化渗透，迭代健康化、低糖化配方；依托金华总部与多地产能拓展区域市场，稳固含乳饮料份额。公司规划以“甜牛奶”大单品为基，向多元含乳饮料与功能饮品延伸。`,
    invest: `聚焦含乳饮料主业产线升级与渠道下沉，稳健投入区域产能与品牌传播，无大规模跨界扩产。资本开支以新基地与产线为主，强调稳健规模扩张。`,
    productDesc: `主营含乳饮料、蛋白饮料等，为瓶装、利乐包多形态乳基饮品，是乳蛋白下游规模化应用企业。`,
    image: '',
  },
  {
    id: 'namchow',
    name: '南侨食品集团（上海）股份有限公司',
    province: '上海',
    short: '南侨食品',
    category: '烘焙油脂 / 奶油 / 冷冻面团',
    excludeFromMap: true,
    production: `烘焙油脂与奶油专业供应商（A股 605339），总部上海，主营烘焙油脂、人造奶油、冷冻面团等，服务连锁烘焙与餐饮客户；持续扩大奶油与烘焙油脂产能，深耕本土烘焙渠道。公司在天津、广州、重庆等地布局生产基地，是烘焙油脂行业的重要参与者。`,
    patent: `技术聚焦烘焙油脂乳化、人造奶油质构与冷冻面团工艺改良，拥有成熟油脂复配与冷链适配专利；在含乳脂奶油方向积累丰富应用经验。公司围绕烘焙油脂与奶油形成配方、工艺与冷链储备，并推进自动化生产。`,
    future: `深耕烘焙大客户与餐饮定制，扩大含乳脂奶油、冷冻面团高附加值品类；顺应烘焙消费多元化扩大产能与渠道覆盖。公司规划以“烘焙油脂+奶油+冷冻面团”综合方案，提升一站式服务能力。`,
    invest: `稳健投入烘焙油脂与奶油产线升级、区域产能布局，强化本土烘焙供应链服务，提升高端产品占比。资本开支以产线与区域基地为主，聚焦主业深耕。`,
    productDesc: `主营烘焙油脂、人造奶油、含乳脂奶油、冷冻面团等，为块状、膏状、冷冻多形态，是奶油与乳蛋白类下游应用企业。`,
    image: '',
  },
  {
    id: 'fonterra',
    name: '恒天然合作集团有限公司',
    province: '新西兰',
    short: '恒天然 Fonterra',
    category: '国际乳品原料供应商 / 酪蛋白酸盐',
    excludeFromMap: true,
    production: `新西兰最大乳品合作社、全球领先酪蛋白酸盐与乳蛋白原料供应商（安佳 Anchor 等品牌），向亚太食品与营养企业大量供应酪蛋白酸钠 / 酪蛋白胶束；是康巴圣德在国际市场的行业对标与潜在竞合对象。公司掌控新西兰约 80% 原奶收集，拥有从牧草到乳蛋白的全球供应链。`,
    patent: `在乳清蛋白、酪蛋白胶束、钠酪蛋白等乳蛋白加工工艺拥有全球领先技术储备，与亚太食品制造商建立长期技术供应关系；持续投入清洁标签与功能化乳蛋白研发。公司围绕乳蛋白高溶解性、高纯度与功能性形成核心技术壁垒。`,
    future: `依托新西兰奶源成本与地理优势，持续扩大面向中国及亚太的乳蛋白原料供应；推进高纯度、高溶解性酪蛋白产品，顺应亚太乳蛋白需求高增。公司规划以高附加值乳蛋白与专业营养为主，强化对华长期供应合作。`,
    invest: `聚焦乳蛋白深加工产能与亚太供应链建设，强化与中国食品制造商的直销与定制合作，巩固全球酪蛋白酸盐供应地位。资本开支以乳蛋白深加工与亚太渠道为主，强调长期战略合作。`,
    productDesc: `主营全脂乳粉、酪蛋白酸钠、酪蛋白胶束、乳清蛋白等乳蛋白原料及 Anchor 终端乳制品，为粉末、罐装多形态，是国际乳蛋白原料供应核心。`,
    image: '',
  },
]

// ===================== 上市公司 / 同行 增强信息 =====================
// 集中维护，避免污染各公司原始 production / patent 等文案字段；下方统一合并进 companies
//   isListed : 是否上市公司
//   stock    : 上市信息 { market 市场, board 板块, code 股票代码, exchange 交易所 }
//   intro    : 公司简介（上市公司撰写更详尽，非上市公司为精炼版）
//   peers    : 同行业对标企业（同行）id 列表，用于详情页展示与跳转
export const companyMeta = {
  // ---------- 上市公司（A股 / H股） ----------
  'jiangsu-jiahe': {
    isListed: true,
    stock: { market: 'A股', board: '沪市主板', code: '605300', exchange: '上交所' },
    intro: '苏州佳禾食品工业股份有限公司（证券简称：佳禾食品，代码：605300）成立于 2001 年，2021 年 4 月登陆上交所主板，总部位于江苏苏州，是国内粉末油脂、植脂末及咖啡、植物基配料领域的头部企业。核心产品涵盖功能性植脂末、粉末油脂、无菌咖啡液、即饮咖啡与有机植物奶，下游覆盖茶饮、咖啡、新零售等场景。2025 年营收 22.56 亿元，其中咖啡业务 3.61 亿元（同比 +29.59%）、植物基 1.30 亿元（同比 +21.55%）；已完成 7.25 亿元定增用于咖啡扩产，并规划 10 亿元建设海门超级植物奶项目。公司拥有省级工程技术研究中心与大量粉末油脂 / 植物基发明专利，参与起草《植脂末》《粉末油脂》等多项国家标准，是行业技术标杆，持续向健康化、功能型高端配料升级并加速东南亚等海外市场布局。',
    peers: ['fujian-bangling', 'henan-boxin', 'zhejiang-boduo', 'jiangxi-hengding', 'guangdong-yuanjian', 'xiangpiao', 'hiroad'],
  },
  'jiangsu-taihe': {
    isListed: true,
    stock: { market: 'A股', board: '沪市主板', code: '600526', exchange: '上交所' },
    intro: '南通泰禾化工股份有限公司（证券简称：泰禾股份，代码：600526）是国内农药原药与功能精细化学品上市企业，总部位于江苏南通，在南通、徐州、江西建有三大生产基地。公司主营新型低毒杀虫剂、杀菌剂及高端农药中间体，拥有 67 项新型杀虫剂核心专利，可自主创制新型农药化合物，是绿色农药创制领域的重要参与者。2025 年获批年产 8000 吨苄草丹、5000 吨野麦畏等技改项目，并投资约 1.5 亿美金建设埃及 8 万吨农药及功能化学品海外生产基地，推进全球化植保产能布局。需说明的是，泰禾化工主营聚焦精细化工植保领域，与食品级酪蛋白、生物蛋白配料无直接关联，本看板将其列为关联展示企业，不代表其属于酪蛋白酸钠下游应用。',
    peers: [],
  },
  'milkground': {
    isListed: true,
    stock: { market: 'A股', board: '沪市主板', code: '600882', exchange: '上交所' },
    intro: '上海妙可蓝多食品科技股份有限公司（证券简称：妙可蓝多，代码：600882）是国内奶酪行业龙头企业，总部位于上海，实控人为内蒙蒙牛。公司 2025 年营收 56.32 亿元（同比 +16.29%），2026 年一季度营收 16.26 亿元（同比 +31.81%），部分定制化产品阶段性供不应求。公司依托蒙牛体系协同，推进奶酪加工与乳清处理关键技术，落地 MCC 酪蛋白胶束等高附加值乳蛋白产品，并拥有长春工厂（年产 3 万吨级原制奶酪）稳定供应体系。公司与吉林大学联合开发奶酪 / 乳清深加工技术，专利集中于再制奶酪乳化、原制奶酪量产与乳清高值化利用。在清洁标签与高蛋白趋势下，公司持续扩大乳蛋白应用规模，重点布局功能营养、运动营养等高增长品类，是康巴圣德在国际国内奶酪与乳蛋白赛道的重点对标对象。',
    peers: ['yili', 'mengniu', 'feihe', 'bright-dairy', 'newhope-dairy', 'panda-dairy', 'fonterra'],
  },
  'yili': {
    isListed: true,
    stock: { market: 'A股', board: '沪市主板', code: '600887', exchange: '上交所' },
    intro: '内蒙古伊利实业集团股份有限公司（证券简称：伊利股份，代码：600887）创立于 1993 年，1996 年成为 A 股乳制品第一股，总部位于内蒙古呼和浩特，是中国规模最大、品类最全的乳制品龙头企业。公司在全球建成 77 个生产基地、15 个创新中心，2025 年建成国内首条商业化脱盐乳清粉生产线（年处理 4 万吨甜乳清液），2026 年 3 月奶酪三期 1 万吨原制马苏里拉产线投产。公司累计国内外发明专利授权 1049 件（居中国乳企第一），在乳铁蛋白、β-酪蛋白高效分离制备等方向取得标志性创新。依托全产业链布局，伊利持续发力乳清国产化与奶酪精深加工，强化原制奶酪、脱盐乳清粉、乳铁蛋白等高附加值产品自给，顺应高蛋白与清洁标签趋势巩固龙头地位。',
    peers: ['mengniu', 'feihe', 'bright-dairy', 'newhope-dairy', 'milkground', 'panda-dairy', 'fonterra'],
  },
  'mengniu': {
    isListed: true,
    stock: { market: 'H股', board: '港交所主板', code: 'HK2319', exchange: '港交所' },
    intro: '中国蒙牛乳业有限公司（证券简称：蒙牛，代码：HK2319）2004 年于港交所上市，总部位于内蒙古呼和浩特，是国内头部乳制品企业，旗下控股奶酪龙头妙可蓝多。公司 2026 年 1 月“奶立方”项目投产，聚焦 D90 脱盐乳清粉自主研发，已实现 D90 脱盐乳清粉、乳铁蛋白等产品下线，填补国内高端乳清原料产业化空白。公司依托农业农村部乳品精深加工重点实验室，在乳清蛋白、乳铁蛋白、酪蛋白胶束等核心配料取得一批工艺突破，并牵头中国百万奶牛基因改良计划。蒙牛围绕奶酪、乳脂、乳清推进国产替代，借助体系内协同提升乳蛋白综合利用率，持续布局功能与运动营养品类。',
    peers: ['yili', 'feihe', 'bright-dairy', 'newhope-dairy', 'milkground', 'panda-dairy', 'fonterra'],
  },
  'feihe': {
    isListed: true,
    stock: { market: 'H股', board: '港交所主板', code: 'HK6186', exchange: '港交所' },
    intro: '中国飞鹤有限公司（证券简称：飞鹤，代码：HK6186）2009 年于港交所上市，总部位于北京，是国内婴幼儿配方奶粉龙头企业，核心基地位于黑龙江。公司 2012 年建成脱盐乳清液生产线率先打破国外垄断，2022 年建成国内首条乳铁蛋白自动化生产线，乳铁蛋白纯度稳定 95% 以上，拥有 16 种关键核心原料自研自产能力。2025 年于内蒙古赤峰投建二期乳品深加工项目，继续布局脱盐乳清与酪蛋白生产，并发布“乳蛋白鲜萃活性工艺”，直接从鲜奶萃取乳清蛋白、绕开传统“先做奶酪再提乳清”路线。飞鹤以鲜奶直萃活性乳蛋白工艺为核心，持续扩大脱盐乳清、酪蛋白、乳铁蛋白等核心原料自主化，降低对进口乳清蛋白依赖。',
    peers: ['yili', 'mengniu', 'bright-dairy', 'newhope-dairy', 'milkground', 'panda-dairy', 'fonterra'],
  },
  'bright-dairy': {
    isListed: true,
    stock: { market: 'A股', board: '沪市主板', code: '600597', exchange: '上交所' },
    intro: '光明乳业股份有限公司（证券简称：光明乳业，代码：600597）是华东区域老牌乳制品上市企业，总部位于上海，前身可追溯到 1911 年，拥有“优倍”“莫斯利安”等知名低温鲜奶与常温酸奶品牌。公司以低温鲜奶、酸奶、奶酪为核心品类，依托华东冷链渠道与新鲜短保产品矩阵建立区域壁垒。公司技术聚焦低温乳品发酵、乳蛋白稳态化与奶酪工艺改良，在巴氏鲜奶活性保留、酸奶质构稳定方向具备成熟工艺积累。顺应高蛋白与清洁标签趋势，光明持续扩大乳蛋白应用、强化华东冷链与新鲜短保产品矩阵，稳固区域乳业领先地位。',
    peers: ['yili', 'mengniu', 'feihe', 'newhope-dairy', 'milkground', 'panda-dairy'],
  },
  'newhope-dairy': {
    isListed: true,
    stock: { market: 'A股', board: '深市主板', code: '002946', exchange: '深交所' },
    intro: '新希望乳业股份有限公司（证券简称：新希望乳业，代码：002946）2019 年于深交所上市，总部位于四川成都，是西南区域低温乳制品头部企业。公司秉持“鲜战略”，以低温鲜奶与特色酸奶为核心，旗下华西、雪兰等区域品牌覆盖川渝及全国，低温产能与冷链网络持续扩张。公司技术聚焦低温乳品活性保留、发酵菌种选育与乳蛋白稳态化，在巴氏鲜奶与功能性酸奶方向具备成熟工艺。新希望乳业借西南区位优势深耕本地市场并稳步全国化拓展，持续强化低温乳品高端化与高蛋白、功能型产品占比。',
    peers: ['yili', 'mengniu', 'feihe', 'bright-dairy', 'milkground', 'panda-dairy'],
  },
  'hiroad': {
    isListed: true,
    stock: { market: 'A股', board: '创业板', code: '300915', exchange: '深交所' },
    intro: '上海海融食品科技股份有限公司（证券简称：海融科技，代码：300915）2010 年成立、2020 年登陆创业板，总部位于上海，是烘焙茶饮行业专业原料供应商。公司主营含乳脂植脂奶油、UHT 淡奶油、稀奶油、植脂奶油、蛋白饮料、果酱、巧克力与冰淇淋等，年报明确主要原材料包含酪蛋白酸钠（与油脂、稀奶油、淀粉糖并列），是酪蛋白酸钠的直接工业采购方。公司 2024 年获发明专利“一种植物基酪蛋白酸钠替代物的制备及应用”，以植物蛋白分级浸提与改性实现乳液体系对酪蛋白酸钠的替代。海融推进未来食品产业园建设，印度工厂第二条产线投产后总产能升至 3.5 万吨/年，并在泰国、印尼、越南等设经销网络，加快全球化布局。',
    peers: ['ligao', 'namchow', 'panda-dairy', 'xiangpiao', 'jiangsu-jiahe'],
  },
  'panda-dairy': {
    isListed: true,
    stock: { market: 'A股', board: '创业板', code: '300898', exchange: '深交所' },
    intro: '熊猫乳品集团股份有限公司（证券简称：熊猫乳品，代码：300898）创建于 1996 年，2020 年登陆创业板，总部位于浙江温州，在浙江、山东、海南建生产基地、上海设销售与应用技术服务中心。公司主营熊猫牌炼乳、奶酪、奶油、奶酱及椰达牌椰浆椰乳，产品多次获行业荣誉，是专业乳制品企业。公司技术聚焦炼乳浓缩、奶酪与奶油工艺改良、乳蛋白稳态化，实施品牌提升与国际化战略，依托多基地产能拓展餐饮茶饮与零售渠道。熊猫乳品是炼乳 / 奶油 / 奶酪细分品类的重要参与者，与烘焙、餐饮及乳品企业形成广泛协同。',
    peers: ['yili', 'mengniu', 'feihe', 'bright-dairy', 'newhope-dairy', 'milkground', 'hiroad', 'namchow'],
  },
  'xiangpiao': {
    isListed: true,
    stock: { market: 'A股', board: '沪市主板', code: '603711', exchange: '上交所' },
    intro: '香飘飘食品股份有限公司（证券简称：香飘飘，代码：603711）2005 年成立、2017 年登陆上交所，总部位于浙江湖州，是杯装奶茶与即饮饮品头部企业。公司 2024 年营收约 10.87 亿元，拥有 3 项发明专利、15 项实用新型与 103 项外观专利，是农业产业化龙头企业、植脂末与含乳饮料大规模下游用户。公司参与国家标准与团体标准制定，在杯装奶茶、即饮乳茶配方与包装自动化方向有成熟专利积累。香飘飘持续迭代杯装奶茶与即饮乳茶产品矩阵，顺应健康化趋势优化配方，依托品牌与渠道优势扩大含乳饮料与固体冲调品类市场份额。',
    peers: ['fujian-bangling', 'jiangsu-jiahe', 'jiangxi-hengding', 'guangdong-yuanjian', 'liziyuan', 'hiroad'],
  },
  'ligao': {
    isListed: true,
    stock: { market: 'A股', board: '创业板', code: '300973', exchange: '深交所' },
    intro: '立高食品股份有限公司（证券简称：立高食品，代码：300973）2000 年成立、2021 年登陆创业板，总部位于广东广州，是烘焙与冷冻烘焙原料头部企业。公司主营奶油、水果制品、酱料、冷冻烘焙半成品等，为烘焙连锁与餐饮客户提供一站式原料，持续扩大奶油与冷冻烘焙产能。公司技术聚焦奶油乳化、搅打充气稳定性与冷冻烘焙工艺改良，在含乳脂奶油、冷冻烘焙半成品方向积累丰富专利。立高食品深耕“大烘焙”渠道并拓展餐饮茶饮大客户，提供个性化定制原料，持续迭代奶油、冷冻烘焙与酱料产品，扩大乳脂与蛋白基配料应用。',
    peers: ['hiroad', 'namchow', 'panda-dairy'],
  },
  'byhealth': {
    isListed: true,
    stock: { market: 'A股', board: '创业板', code: '300146', exchange: '深交所' },
    intro: '汤臣倍健股份有限公司（证券简称：汤臣倍健，代码：300146）1995 年成立、2010 年登陆创业板，总部位于广东珠海，是膳食营养补充剂行业龙头。公司主营蛋白粉、乳清蛋白粉、益生菌与维生素矿物质等营养品，蛋白类产品是酪蛋白 / 乳清蛋白等乳基蛋白的重要下游应用，依托全球原料采购体系稳定供应。公司持有多项营养配方、蛋白复配与功能因子专利，建有自有研发体系与透明工厂，在乳清蛋白、胶原蛋白、功能性蛋白粉方向持续迭代。汤臣倍健顺应健身与老龄化带来的高蛋白需求，扩大乳清 / 酪蛋白类营养品占比，强化全球原料直采与科学营养品牌战略。',
    peers: ['guangdong-duohe'],
  },
  'liziyuan': {
    isListed: true,
    stock: { market: 'A股', board: '沪市主板', code: '605337', exchange: '上交所' },
    intro: '浙江李子园食品股份有限公司（证券简称：李子园，代码：605337）1994 年成立、2021 年登陆上交所，总部位于浙江金华，是含乳饮料区域龙头。公司集含乳饮料及其他饮料研发、生产、销售于一体，核心“甜牛奶”含乳饮料全国化布局，产线规模化、渠道下沉深入，是乳蛋白下游规模化应用企业。公司在含乳饮料配方稳定性、杀菌与包装自动化方向有成熟工艺积累，拥有多项饮料生产相关设备与配方专利。李子园持续扩大含乳饮料核心单品全国化渗透，迭代健康化、低糖化配方，依托多地产能拓展区域市场，稳固含乳饮料份额。',
    peers: ['xiangpiao', 'byhealth'],
  },
  'namchow': {
    isListed: true,
    stock: { market: 'A股', board: '沪市主板', code: '605339', exchange: '上交所' },
    intro: '南侨食品集团（上海）股份有限公司（证券简称：南侨食品，代码：605339）1995 年成立、2021 年登陆上交所，总部位于上海，是烘焙油脂与奶油专业供应商。公司主营烘焙油脂、人造奶油、冷冻面团等，服务连锁烘焙与餐饮客户，持续扩大奶油与烘焙油脂产能、深耕本土烘焙渠道。公司技术聚焦烘焙油脂乳化、人造奶油质构与冷冻面团工艺改良，拥有成熟油脂复配与冷链适配专利，在含乳脂奶油方向积累丰富应用经验。南侨食品深耕烘焙大客户与餐饮定制，扩大含乳脂奶油、冷冻面团高附加值品类，顺应烘焙消费多元化扩大产能与渠道覆盖。',
    peers: ['hiroad', 'ligao', 'panda-dairy'],
  },

  // ---------- 非上市公司（精炼简介 + 同行） ----------
  'fujian-bangling': {
    isListed: false,
    intro: '福建邦领食品有限公司是闽粤区域中外合资大型植脂末专业生产企业，厂区面积 1.8 万㎡，拥有 3 条国际先进植脂末生产线，年产能超 5 万吨，可生产含脂率 20%-70% 全系列植脂末。公司通过 ISO9000/ISO22000/ISO14000 体系认证，产品出口西非等海外市场，产能利用率长期维持高位，是康巴圣德在茶饮配料赛道的核心客户之一。',
    peers: ['jiangsu-jiahe', 'henan-boxin', 'zhejiang-boduo', 'jiangxi-hengding', 'jiangxi-changhui', 'guangdong-yuanjian', 'xiangpiao'],
  },
  'guangdong-maiji': {
    isListed: false,
    intro: '佛山麦吉新材料科技有限公司专注水性高分子材料与皮革化学品研发生产，2024 年智慧工厂投产（设计产能 1.5 万吨），主营水性涂层、皮革化工助剂，与食品级酪蛋白应用无关，本看板仅作关联展示。',
    peers: [],
  },
  'sichuan-baoshun': {
    isListed: false,
    intro: '四川宝顺生物技术有限公司是国家级高新技术企业，主营胰蛋白胨（胰酪蛋白胨）、食品加工用蛋白肽等功能性蛋白配料，是酪蛋白深加工下游应用企业。公司自研胰蛋白胨打破国外垄断、降本约 50%，远销 10 余国，蛋白深加工项目环评批复备案 8000 万，规划 5 年产值破 1.5 亿元。',
    peers: ['jiangsu-lianfeng', 'henan-jinyumi', 'guangdong-duohe', 'fonterra'],
  },
  'jiangsu-lianfeng': {
    isListed: false,
    intro: '常州联丰生物工程有限公司专注生物发酵制品、食品功能性配料与天然食品添加剂生产，核心蛋白基乳化剂、稳定剂产品广泛应用乳蛋白原料，常年稳产运行，服务中小食品企业配套需求。',
    peers: ['sichuan-baoshun', 'henan-jinyumi', 'guangdong-duohe'],
  },
  'guangdong-yuanjian': {
    isListed: false,
    intro: '广东源健食品有限公司是华南区域专业食品配料、固体饮料与营养基料生产企业，植脂末、蛋白固体饮料、食品乳化基料等核心产品大量应用酪蛋白酸钠，订单充足、持续满产，是康巴圣德在华南茶饮配料赛道的重要客户。',
    peers: ['fujian-bangling', 'jiangsu-jiahe', 'henan-boxin', 'zhejiang-boduo', 'jiangxi-hengding', 'jiangxi-changhui', 'xiangpiao'],
  },
  'hebei-haoshidai': {
    isListed: false,
    intro: '好时代胶业迁安有限公司主营乳胶、橡胶制品，乳胶制品分三期建设，一期年产气球 7.2 亿个、手指套 18 亿只，与食品级酪蛋白应用无关，本看板仅作关联展示。',
    peers: [],
  },
  'henan-jinyumi': {
    isListed: false,
    intro: '河南金玉米生物科技有限公司依托玉米深加工产业，主营生物基食品原料、淀粉衍生物、乳蛋白改性配料与食品乳化稳定剂，是中原区域核心生物食品原料供应商，常年满产运行。',
    peers: ['sichuan-baoshun', 'jiangsu-lianfeng', 'guangdong-duohe', 'henan-boxin'],
  },
  'henan-boxin': {
    isListed: false,
    intro: '河南博欣生物科技有限公司是浙江博多集团北方核心生产基地，专业生产新式茶饮配料、植脂末与固体饮料，占地 5 万㎡、年产能超 10 万吨，是康巴圣德在华北茶饮供应链的核心客户。',
    peers: ['zhejiang-boduo', 'fujian-bangling', 'jiangsu-jiahe', 'jiangxi-hengding', 'jiangxi-changhui', 'guangdong-yuanjian'],
  },
  'zhejiang-ganwei': {
    isListed: false,
    intro: '浙江敢为实业有限公司位于浙江东阳，主营橡胶、塑料制品、玩具、第一类医疗器械等轻工制造，注册资本 1000 万元，与酪蛋白酸钠下游应用无关，本看板仅作关联展示。',
    peers: ['hebei-haoshidai'],
  },
  'jiangxi-hengding': {
    isListed: false,
    intro: '江西恒顶食品有限公司是全国大型食品配料、植脂末与固体饮料头部生产企业，总投资 23.5 亿元建设“恒顶生物食品健康产业园”，现年产植脂末/酶解谷物粉 16 万吨、大米蛋白 2 万余吨，长期满产、供货全国头部品牌。',
    peers: ['fujian-bangling', 'jiangsu-jiahe', 'henan-boxin', 'zhejiang-boduo', 'jiangxi-changhui', 'guangdong-yuanjian', 'xiangpiao'],
  },
  'jiangxi-changhui': {
    isListed: false,
    intro: '江西长汇食品有限公司是中部区域专业植脂末、固体食品配料生产企业，4 条生产线、年产能 7 万吨，高新技术与专精特新企业，官网明确“以植物油、麦芽糖浆、酪蛋白为主要原料”，产能稳定、深耕中部下沉市场。',
    peers: ['fujian-bangling', 'jiangsu-jiahe', 'henan-boxin', 'zhejiang-boduo', 'jiangxi-hengding', 'guangdong-yuanjian'],
  },
  'shandong-chunhua': {
    isListed: false,
    intro: '潍坊春华化工有限公司是微型化工贸易企业（注册资本 50 万元），主营化工原料、印染助剂及化学试剂批发，无自有生产产线，与食品级酪蛋白应用无关，本看板仅作关联展示。',
    peers: [],
  },
  'zhejiang-boduo': {
    isListed: false,
    intro: '浙江博多食品科技有限责任公司是博多集团总部运营主体，主营品牌运营、研发与渠道管理，生产由集团七大基地承接；德清九润基地投资 5 亿元、21 条线年产能 12 万吨，全系茶饮配料核心配方均使用酪蛋白酸钠，是康巴圣德在茶饮供应链的核心大客户。',
    peers: ['henan-boxin', 'fujian-bangling', 'jiangsu-jiahe', 'jiangxi-hengding', 'jiangxi-changhui', 'guangdong-yuanjian'],
  },
  'sichuan-jiahe-group': {
    isListed: false,
    intro: '成都嘉禾实业集团有限公司是综合性实业集团，主营农副产品加工、种业种植、交通工程、地产配套与酒类产业，完全不涉及酪蛋白原料业务，本看板仅作关联展示。',
    peers: [],
  },
  'guangdong-duohe': {
    isListed: false,
    intro: '广东多合生物科技有限公司专注功能性保健食品、蛋白粉与固体饮料研发生产，乳制品、饮品、烘焙专用蛋白基助剂深度应用酪蛋白原料，2024 年立项 3.10 亿元健康食品生产项目，致力于高端食品复配与功能性助剂。',
    peers: ['sichuan-baoshun', 'jiangsu-lianfeng', 'henan-jinyumi', 'byhealth'],
  },
  'fonterra': {
    isListed: false,
    intro: '恒天然合作集团有限公司（Fonterra）是新西兰最大乳品合作社、全球领先酪蛋白酸盐与乳蛋白原料供应商（安佳 Anchor 等品牌），向亚太食品与营养企业大量供应酪蛋白酸钠/酪蛋白胶束，是康巴圣德在国际市场的行业对标与潜在竞合对象。',
    peers: ['yili', 'mengniu', 'feihe', 'bright-dairy', 'newhope-dairy', 'milkground'],
  },
}

// 将增强信息合并进 companies（不影响原始 production / patent / future / invest 等文案字段）
companies.forEach(c => {
  const m = companyMeta[c.id]
  if (m) Object.assign(c, m)
})

// 为未配置产品图的上市公司 / 关联企业，按品类关键词自动匹配分类产品图（public/assets/company-products/）
// 已有专属产品图（image 非空）的公司保持原图不变；其余按业务品类兜底，确保详情页不再出现 placeholder
const CATEGORY_IMG = [
  { kw: ['乳清', '奶粉', '婴配', '乳粉', '酪蛋白酸盐', '脱盐'], img: 'assets/company-products/cat-milkpowder.png' },
  { kw: ['炼乳'], img: 'assets/company-products/cat-condensedmilk.png' },
  { kw: ['液态奶', '酸奶', '鲜奶', '含乳饮料', '乳饮料'], img: 'assets/company-products/cat-liquidmilk.png' },
  { kw: ['奶酪'], img: 'assets/company-products/cat-cheese.png' },
  { kw: ['奶油', '烘焙', '油脂', '冷冻'], img: 'assets/company-products/cat-creambaking.png' },
  { kw: ['蛋白', '保健', '营养', '膳食'], img: 'assets/company-products/cat-protein.png' },
  { kw: ['奶茶', '植脂末', '固体饮料', '饮品', '咖啡'], img: 'assets/company-products/cat-milktea.png' },
  { kw: ['化工', '橡胶', '塑料', '乳胶', '玩具', '农业', '酒', '贸易', '材料'], img: 'assets/company-products/cat-industrial.png' },
]
companies.forEach(c => {
  if (c.image) return
  const cat = c.category || ''
  for (const rule of CATEGORY_IMG) {
    if (rule.kw.some(k => cat.includes(k))) { c.image = rule.img; break }
  }
})

// 省份 → 公司列表（用于地图点击弹窗）；excludeFromMap=true 的公司仅用于下游客户热力图，不进入经营数据页地图
export const companiesByProvince = companies.reduce((map, c) => {
  if (c.excludeFromMap) return map
  if (!map[c.province]) map[c.province] = []
  map[c.province].push(c)
  return map
}, {})

// 有公司的省份（用于地图高亮 / 散点 / 飞线）
export const activeProvinces = Object.keys(companiesByProvince)

// 省份中心经纬度（用于散点 / 飞线坐标），坐标为近似行政中心
export const provinceCenters = {
  福建: [119.3, 26.1],
  江苏: [119.8, 33.0],
  广东: [113.6, 23.5],
  四川: [104.0, 30.6],
  河北: [115.5, 38.5],
  河南: [113.6, 34.0],
  浙江: [120.2, 29.2],
  江西: [115.9, 27.6],
  山东: [118.0, 36.4],
}

// 枢纽：康巴圣德总部（四川甘孜）
export const hubCenter = [101.5, 30.0]

export function getCompanyById(id) {
  return companies.find(c => c.id === id) || null
}

// 解析某公司的同行业对标企业（同行）：返回合并了公司对象的数组，供详情页渲染与跳转
export function getPeersOf(id) {
  const c = getCompanyById(id)
  if (!c || !Array.isArray(c.peers)) return []
  return c.peers.map(pid => getCompanyById(pid)).filter(Boolean)
}

// 统计上市公司数量（用于热力图页“上市公司 N 家”标识）
export function countListedCompanies() {
  return companies.filter(c => c.isListed).length
}
